import React from 'react';
import { MantineProvider as MantineUIProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import '@mantine/core/styles.css';
import { theme } from '../../theme';

interface MantineProviderProps {
  children: React.ReactNode;
}

const MantineProvider = ({ children }: MantineProviderProps) => {
  return (
    <MantineUIProvider theme={theme}>
      <Notifications />
      {children}
    </MantineUIProvider>
  );
};

export default MantineProvider;
